import { createSelector } from 'reselect';
import { showPrsRolloutSelector } from 'ai/selectors/testTarget/showPrsRolloutSelector';

const isGenAIPRSKillswitchEnabled = () => Sephora.configurationSettings?.genAIPRS?.isEnabled;

const isGenAIPRSEnabledSelector = createSelector(showPrsRolloutSelector, showPrsRollout => {
    return isGenAIPRSKillswitchEnabled() && showPrsRollout;
});

export {
    isGenAIPRSEnabledSelector, isGenAIPRSKillswitchEnabled
};
